import axios from "axios";
import { addBaseQueryParams, BaseQueryParams } from "@commons/utils/APIParams";
import { config } from "@commons/config.instance";
import { DateTime } from "luxon";
import { TabellaWFRecord } from "@commons/mapping/TabellaWFRecord";
import {DataTablesSchema} from "@commons/mapping/DataTablesSchema";
import {DashboardWFRecord, DashboardWFRootDetails} from "@commons/mapping/dashboard.types";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";

//type ReactQueryOptions=Omit<UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,'initialData'> & { initialData?: () => undefined };
export interface DashboardWFParams extends BaseQueryParams {
  idAziendaMaster: number | null,
  idAzienda: number | null,
  anno: number,
  mese: number,
  tabellaWF: TabellaWFRecord | null,
  codTabella: string | null,
}

export class DashboardWFParams {
  static isValid = (p: DashboardWFParams) => p.idAzienda && p.idAziendaMaster && p.anno && p.mese && p.tabellaWF;
}

export const getDashboardWF = (filter: DashboardWFParams) => {
  //const token='655d07e65e52d75344f5809f0c279d14'; //auth_token=${token}
  const params: string[] = addBaseQueryParams(filter);
  if (filter.anno) params.push("anno=" + filter.anno);
  if (filter.mese) params.push("mese=" + filter.mese);
  if (filter.tabellaWF) {
    if (filter.tabellaWF.idTipoTabella || filter.tabellaWF.idTipoTabella === 0) params.push("idTipoTabella=" + filter.tabellaWF.idTipoTabella);
    if (filter.codTabella) params.push("codTabella=" + filter.codTabella);
  }
  const url = config.getBaseUrl("HR") + `/tool/${filter.idAziendaMaster}-${filter.idAzienda}/workflow/dashboard?${params.length > 0 ? encodeURI(params.join("&")) : ""}`;
  return axios(url).then(res => res.data);
};

export interface MonitorWFParams extends BaseQueryParams {
  idAziendaMaster: number,
  idAzienda: number,
  idDip: number | null,
  dataDa: Date, // da indicare come aaaammdd
  dataA: Date, // da indicare come aaaammdd
}

/**
 * Da usarsi esclusivamente con la dashboard, ha infatti bisogno dell'idDip!
 * @param filter
 * @param _useaxios
 */
export const listMonitorWF = (filter: MonitorWFParams, _useaxios: boolean) => {
  const params: string[] = addBaseQueryParams(filter);
  if (filter.dataDa) params.push("dataDa=" + DateTime.fromJSDate(filter.dataDa).toFormat("yyyyLLdd"));
  if (filter.dataA) params.push("dataA=" + DateTime.fromJSDate(filter.dataA).toFormat("yyyyLLdd"));
  //params.push('useDefaultPropertyNamingStrategy=true') // Viene inclusa da Axios.interceptors...
  params.push("view=Grid");
  params.push("mostra-tutto=true");
  const url = config.getBaseUrl("FPNet") + `/tool/${filter.idAziendaMaster}-${filter.idAzienda}/workflow/monitor/${filter.idDip}?${params.length > 0 ? encodeURI(params.join("&")) : ""}`;
  return axios(url).then(res => res.data);
};

export const getMonitorWF = (url: string | null, _useaxios: boolean) => {
  const params: string[] = [];
  //params.push('useDefaultPropertyNamingStrategy=true') // Viene inclusa da Axios.interceptors...
  params.push("view=Full");
  const finalUrl = url + `?${params.length > 0 ? encodeURI(params.join("&")) : ""}`;
  return axios(finalUrl).then(res => res.data);
};

export interface DashboardWFData extends DataTablesSchema<DashboardWFRecord> {
  details: DashboardWFRootDetails
}